import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'qLO7Y0o8JeX267wSmYXaMavjLDKyM42dPDLyzmAF',
  authDomain: 'pws-broadmoor-2021.firebaseapp.com',
  databaseURL: 'https://pws-broadmoor-2021-default-rtdb.firebaseio.com',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.database();

export default db;



// WEBPACK FOOTER //
// ./src/db.js